module.exports = __webpack_public_path__ + "img/voice.2aad2155.png";